if (!customElements.get('quick-add')) {
  customElements.define(
    'quick-add',
    class QuickAdd extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          cardImage: '[class*="js-card__image"]',
          productCard: '[data-product-card]',
          quickAddSubmit: '[type="submit"]',
          showVariants: '[data-quick-add-show-variants]',
          productCardPrice: '[data-product-card-price]',
          price: '[data-price]',
          variantPrice: '[data-variant-price]'
        };

        this.classes = {
          active: 'active',
          cardImageMain: 'js-card__image-main',
          cardImageVariant: 'js-card__image-variant',
          cardImageVariantShow: 'card__image-variant--show'
        }

        this.data = {
          mediaId: 'mediaId',
          variantId: 'variantId'
        }

        this.attr = {
          mediaId: 'data-media-id'
        }
        
        this.onQuickAddEnter = this.onQuickAddEnter.bind(this);
        this.onQuickAddLeave = this.onQuickAddLeave.bind(this);
        this.showVariants = this.showVariants.bind(this);
        this.onProductCardEnter = this.onProductCardEnter.bind(this);
      }

      connectedCallback() {
        this.productCard = this.closest(this.selectors.productCard);
        this.cardImages = this.productCard?.querySelectorAll(this.selectors.cardImage);
        this.mainImage = this.cardImages?.length ? [...this.cardImages].find(ci => ci.classList.contains(this.classes.cardImageMain)) : false;
        this.quickAddShowVariants = this.querySelector(this.selectors.showVariants);
        this.quickAddSubmit = this.querySelectorAll(this.selectors.quickAddSubmit);

        this.productCardPrice = this.productCard.querySelector(this.selectors.productCardPrice);
        this.prices = this.productCardPrice?.querySelectorAll(this.selectors.price);
        this.variantPrices = this.productCardPrice?.querySelectorAll(this.selectors.variantPrice);

        if (!this.cardImages?.length && !this.productCardPrice) return;

        this.initEvents();
      }

      disconnectedCallback() {
        this.offEvents();
      }

      initEvents() {
        this.productCard.addEventListener('mouseenter', this.onProductCardEnter);
        this.quickAddSubmit.forEach((qas) => qas.addEventListener('mouseenter', this.onQuickAddEnter));
        this.addEventListener('mouseleave', this.onQuickAddLeave);
        this.quickAddShowVariants?.addEventListener('click', this.showVariants);
      }

      offEvents() {
        this.productCard.removeEventListener('mouseenter', this.onProductCardEnter);
        this.quickAddSubmit.forEach((qas) => qas.removeEventListener('mouseenter', this.onQuickAddEnter));
        this.removeEventListener('mouseleave', this.onQuickAddLeave);
        this.quickAddShowVariants?.removeEventListener('click', this.showVariants);  
      }

      onQuickAddEnter(e) {
        const target = e.currentTarget;
        const imageId = target.dataset[this.data.mediaId] || false;
        const variantId = target.dataset[this.data.variantId];
        let variantImage, variantPrice;

        if (this.cardImages?.length) {
          if (imageId) {
            variantImage = [...this.cardImages].find(ci => 
              ci.classList.contains(this.classes.cardImageVariant) && 
              ci.getAttribute(this.attr.mediaId) === imageId
            );
          }
          
          variantImage = variantImage ? variantImage : this.mainImage;
  
          this.cardImages.forEach(ci => { 
            if (ci !== variantImage)
              ci.style.opacity = '0'; 
          });
  
          variantImage.style.opacity = '1';
        }

        if (this.productCardPrice) {
          variantPrice = [...this.variantPrices].find(vp => vp.dataset[this.data.variantId] === variantId);
          this.prices.forEach(p => {
            p.style.opacity = '0';
          });

          variantPrice.style.opacity = '1';
        }
            
      }

      onQuickAddLeave(e) {
        if (this.cardImages?.length)
          this.cardImages.forEach(ci => ci.style.opacity = '');

        if (this.productCardPrice)
          this.prices.forEach(p => p.style.opacity = '');
      }

      onProductCardEnter(e) {
        this.classList.remove(this.classes.active);
      }

      showVariants(e) {
        this.classList.add(this.classes.active);
      }
      
    }
  );
}